module.exports = __webpack_public_path__ + "static/media/bliss261.fa8e9694.png";